module.exports = __webpack_public_path__ + "static/an-abstract-poem-of-freedom_2009-9324a8f8faccc133b02a1493d0d24701.jpg";